import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductExpiryAlertsService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI5 + "/api/expiryalerts";


  searchExpiryAlerts(query: string, page: number, size: number, sort: string): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null // Remove single quotes from the query
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; // Construct query parameters

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  downloadExpiryalerts(): Observable<any> {
    return this.http.get(`${this.url}/export`, { responseType: 'arraybuffer', observe: 'response' });
  }

  getExpiryalerts(Page: number, size: number, sort: number): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
}
